<template>
  <div>
    <TabList
      :activeTab="activeTabIndex"
      :customActiveTabStyle="$style.activeTab"
      :customNavStyle="$style.tabNav"
      :customTabStyle="$style.tabLink"
      :tabs="tabs"
      @active-tab-change="handleActiveTabChange"
    />
  </div>
</template>s

<script>
import { ItemTypeConsts, ItemTypeRoutes } from 'client/util/Constants';
import GoogleSettingsMainPanel from 'client/MDM/GoogleSettingsMainPanel';
import MdmVppMainPanel from 'client/MDM/MdmVppMainPanel';
import MdmWindowsSettings from 'client/MDM/MdmWindowsSettings';
import RouterService from 'client/util/RouterService';
import TabList from 'components/TabList/TabList.vue';

export default {
  name: 'MdmMainPanel',

  components: {
    TabList,
  },

  props: {
    initialTabIndex: {
      type: Number,
      default: 0,
    },
    itemType: {
      default: '',
      type: String,
    },
    viewport: {
      default: null,
      type: Object,
    },
  },

  computed: {
    activeTabIndex() {
      return this.initialTabIndex ? this.initialTabIndex : 0;
    },

    tabs() {
      const tabs = [
        {
          title: 'Apple',
          component: MdmVppMainPanel,
          componentProps: {
            itemType: this.itemType,
            viewport: this.viewport,
          },
        },
      ];

      if (this.$hasFeatureFlag(this.$featureFlags.windowsMdmEnrollment)) {
        tabs.push({
          title: 'Windows',
          component: MdmWindowsSettings,
          componentProps: {
            itemType: this.itemType,
            viewport: this.viewport,
          },
        });
      }

      if (this.$hasFeatureFlag(this.$featureFlags.androidEmmMvp)) {
        tabs.push(
          {
            title: 'Google',
            component: GoogleSettingsMainPanel,
          },
        );
      }

      return tabs;
    },
  },

  methods: {

    handleActiveTabChange(tabIndex) {
      let path = ItemTypeRoutes[ItemTypeConsts.mdmSettings];
      if (tabIndex === 0) {
        path = `${path}/apple`;
      }

      if (tabIndex === 1 && this.$hasFeatureFlag(this.$featureFlags.windowsMdmEnrollment)) {
        path = `${path}/windows`;
      }

      if (tabIndex === 1
        && !this.$hasFeatureFlag(this.$featureFlags.windowsMdmEnrollment)
        && this.$hasFeatureFlag(this.$featureFlags.androidEmmMvp)) {
        path = `${path}/google`;
      }

      if (tabIndex === 2
        && this.$hasFeatureFlag(this.$featureFlags.windowsMdmEnrollment)
        && this.$hasFeatureFlag(this.$featureFlags.androidEmmMvp)) {
        path = `${path}/google`;
      }

      RouterService.redirect({
        path,
        viewport: this.viewport,
        vueRouter: this.$router,
      });
    },
  },
};
</script>

<style module>
@value (jcGrey, jcGrey600) from '~css/brand-colors.css';

.activeTab a {
  border-bottom: 2px solid var(--jcPrimary);
  color: jcGrey600;
}

.tabLink {
  color: jcGrey !important;
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 4px;
}

.tabNav {
  margin: 20px 0 10px 20px !important;
}
</style>
